import type { LocaleCode } from "./locale-config";

export type NotFoundCopy = {
  title: string;
  body: string;
  action: string;
};

/**
 * Locale-aware 404 copy used by route `head` (SSR title) and the not-found UI.
 */
export const notFoundCopy: Record<LocaleCode, NotFoundCopy> = {
  "en-ca": {
    title: "Page not found",
    body: "The page you're looking for doesn't exist or has moved.",
    action: "Go home",
  },
  "zh-cn": {
    title: "找不到页面",
    body: "此页面不存在或已移动。",
    action: "返回首页",
  },
  "zh-tw": {
    title: "找不到頁面",
    body: "此頁面不存在或已移動。",
    action: "返回首頁",
  },
  "pa-in": {
    title: "ਪੰਨਾ ਨਹੀਂ ਮਿਲਿਆ",
    body: "ਇਹ ਪੰਨਾ ਮੌਜੂਦ ਨਹੀਂ ਹੈ ਜਾਂ ਬਦਲ ਗਿਆ ਹੈ।",
    action: "ਮੁੱਖ ਪੰਨੇ ਤੇ ਜਾਓ",
  },
  "ko-kr": {
    title: "페이지를 찾을 수 없습니다",
    body: "페이지가 없거나 이동되었습니다.",
    action: "홈으로 이동",
  },
  "fa-ir": {
    title: "صفحه پیدا نشد",
    body: "صفحه‌ای که دنبال آن هستید وجود ندارد یا جابه‌جا شده است.",
    action: "بازگشت به صفحهٔ اصلی",
  },
  "ar-sa": {
    title: "الصفحة غير موجودة",
    body: "الصفحة التي تبحث عنها غير موجودة أو جرى نقلها.",
    action: "العودة إلى الصفحة الرئيسية",
  },
};

export function getNotFoundCopy(locale: LocaleCode): NotFoundCopy {
  return notFoundCopy[locale] ?? notFoundCopy["en-ca"];
}

export function notFoundDocumentTitle(locale: LocaleCode): string {
  const brand =
    locale === "fa-ir" ? "رولین روفینگ" : locale === "ar-sa" ? "رولين روفينغ" : "Revolin Roofing";
  return `${getNotFoundCopy(locale).title} | ${brand}`;
}
